import React from "react";
import VideoCard from "./VideoCard";
import { leaf2, mainLeaf } from "../../assets";

const Videos = () => {
  return (
    <div className="videoPage">
      <div className="gradient"></div>
      <img src={leaf2} className="mainLeaf" alt="" />
      <img src={mainLeaf} className="mainLeaf2" alt="" />
      <div className="title">
        <h1>Our Videos</h1>
        <p>Get updated with our recent blogs</p>
      </div>

      <div className="videos">
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
      </div>
    </div>
  );
};

export default Videos;
